function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationRuleSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db8509"
    },
    d: "M28 35.746c0 2.211-1.79 4-4 4s-4-1.789-4-4a4 4 0 0 1 8 0zM26 11a1.999 1.999 0 1 1-4 0V7a1.999 1.999 0 1 1 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M33 33V16.8a9 9 0 0 0-9-9 9 9 0 0 0-9 9V33Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M41 33c0 2.21-7.059 4-17 4-9.941 0-17-1.79-17-4s7.059-4 17-4c9.941 0 17 1.79 17 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M7 33c0-2 8-9 8-12s18-3 18 0 8 10 8 12-34 2-34 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffe8a0",
      fillOpacity: 1,
      strokeWidth: 1.12972438
    },
    d: "M10.746 27.666c-.817.968-.81.97-1.613 1.932 1.467.926 7.646 4.539 15.261 4.539 4.296 0 9.433-1.504 14.308-4.727-.867-1.047-.87-1.053-1.542-1.836-11.801 7.448-23.313 1.86-26.414.092z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "translate(24 22) scale(.13953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 14.33333397,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    cx: 94.049,
    cy: 93.85,
    rx: 56.06,
    ry: 55.11
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      opacity: 1,
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.4 151.2c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9h12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9z",
    style: {
      fill: "#e01e5a",
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    },
    transform: "translate(-80.164 -80.164) scale(1.28393)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.8 99.4c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9v12.9zm0 6.5c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9H86.5c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9z",
    style: {
      fill: "#36c5f0",
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    },
    transform: "translate(-80.164 -80.164) scale(1.28393)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.6 118.8c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9h-12.9zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9V86.5c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9z",
    style: {
      fill: "#2eb67d",
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    },
    transform: "translate(-80.164 -80.164) scale(1.28393)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M151.2 170.6c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9v-12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9z",
    style: {
      fill: "#ecb22e",
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 11.16363675,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeLinejoin: "round",
      paintOrder: "markers stroke fill",
      strokeLinecap: "square"
    },
    transform: "translate(-80.164 -80.164) scale(1.28393)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRuleSlack);
export default __webpack_public_path__ + "static/media/notificationRuleSlack.eec68c7a29368980dbfb1124667e7b2a.svg";
export { ForwardRef as ReactComponent };